"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.CardLabel = exports.CardActions = exports.CardMetricHeader = exports.CardHeader = exports.CardFooter = exports.CardSecondaryContent = exports.CardBody = exports.CardDecorationImage = void 0;
// external
const react_router_dom_1 = require("react-router-dom");
const react_sizeme_1 = require("react-sizeme");
const React = require("react");
// local
const Badge_1 = require("../../atoms/Badge");
const CircularIcon_1 = require("../../atoms/CircularIcon");
const Collapse_1 = require("../../atoms/Collapse");
const CircularMetric_1 = require("../../atoms/CircularMetric");
const ImgBlock_1 = require("../../atoms/ImgBlock");
const colors_1 = require("../../../../types/colors");
const standardSizes_1 = require("../../../../types/standardSizes");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Card");
const CardWrapper = ({ url, className, onClick, children }) => {
    if (!url) {
        return (React.createElement("div", { onClick: onClick, className: className, "data-test": "card-wrapper" }, children));
    }
    if (env.webLinks) {
        return (React.createElement("a", { href: url, className: className, "data-test": "card-wrapper" }, children));
    }
    return (React.createElement(react_router_dom_1.NavLink, { to: url, className: className, "data-test": "card-wrapper" }, children));
};
const CardDecorationImage = ({ url }) => React.createElement(ImgBlock_1.ImgBlock, { src: url, className: css("decoration") });
exports.CardDecorationImage = CardDecorationImage;
const CardBody = ({ children, decorationImage }) => (React.createElement("div", { "data-test": "card-body", className: css("body") },
    decorationImage && (React.createElement("div", { "data-test": "card-body-decoration-image", className: css("body_decoration") },
        React.createElement(ImgBlock_1.ImgBlock, { src: decorationImage }))),
    React.createElement("div", { "data-test": "card-body-content", className: css("body_inner") }, children)));
exports.CardBody = CardBody;
const CardSecondaryContent = ({ show = false, children, variant }) => {
    const className = css("secondaryContent", `-color-${variant}`);
    return (React.createElement(Collapse_1.Collapse, { isOpened: show },
        React.createElement("div", { className: className }, children)));
};
exports.CardSecondaryContent = CardSecondaryContent;
const CardFooter = ({ children, status = "" }) => (React.createElement("div", { className: css("footer", `-status-${status}`, {
        "-isNote": typeof children === "string"
    }) }, children));
exports.CardFooter = CardFooter;
// TODO - any implementations of card header with datasets should be mapped over to CardMetricHeader
const CardHeader = ({ title, datasets }) => (React.createElement("div", { "data-test": "card-header", className: css("header") },
    React.createElement("h4", null, title),
    datasets && datasets.length ? (React.createElement("div", null, datasets.map((dataset, index) => (React.createElement("div", { "data-test": "metric", key: index },
        React.createElement(CircularMetric_1.CircularMetric, { size: standardSizes_1.TStandardSizes.Small, variant: dataset.variant }, dataset.value)))))) : null));
exports.CardHeader = CardHeader;
const CardMetricHeader = ({ title, datasets }) => {
    return (React.createElement("div", { "data-test": "card-metric-header", className: css("header", { "-metric": true }) },
        React.createElement("h4", null, title),
        React.createElement("div", null, datasets &&
            datasets.map((dataset, index) => (React.createElement("div", { "data-test": "metric", key: index },
                React.createElement(CircularMetric_1.CircularMetric, { size: standardSizes_1.TStandardSizes.Medium, variant: dataset.variant }, dataset.value)))))));
};
exports.CardMetricHeader = CardMetricHeader;
const CardActions = ({ actions }) => {
    return (React.createElement("div", { className: css("actions"), "data-test": "card-actions" }, actions.map((action, i) => (React.createElement("span", { key: i },
        React.createElement(CircularIcon_1.CircularIcon, { className: css("actions_icon"), name: action.icon, to: action.to, onClick: typeof action.onClick === "function"
                ? (event) => {
                    event.stopPropagation();
                    action.onClick(event);
                }
                : null, variant: action.variant }))))));
};
exports.CardActions = CardActions;
const CardLabel = ({ variant = colors_1.TColorVariants.Primary, children }) => (React.createElement("div", { className: css("label") },
    React.createElement(Badge_1.Badge, { variant: variant }, children)));
exports.CardLabel = CardLabel;
const _Card = ({ children, size, className = "", state = "", actions, onClick, url, variant, needsReview = false, isPending = false, status, overflow = null }) => {
    variant = variant ? variant : size.width < 500 ? "narrow" : "wide";
    const cardClassName = css("", `-state-${state}`, `-variant-${variant}`, `-status-${status}`, `-overflow-${overflow}`, {
        "-clickable": !!onClick,
        "-highlight": needsReview,
        "-pending": isPending,
        className
    });
    return (React.createElement(CardWrapper, { url: url, className: cardClassName, onClick: onClick },
        children,
        actions && React.createElement(exports.CardActions, { actions: actions })));
};
exports.Card = (0, react_sizeme_1.withSize)()(_Card);
//# sourceMappingURL=index.js.map